import EnvironmentPicker from './../src/capabilities/picker.js'
window.EnvironmentPicker = EnvironmentPicker
